'use client';

import { useEffect, useRef } from 'react';

import { trackComparisonTableViewed } from '~/lib/analytics/posthog-events';

export function ComparisonViewTracker({
  children,
  verticalSlug,
}: {
  children: React.ReactNode;
  verticalSlug: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const hasFired = useRef(false);

  useEffect(() => {
    const el = ref.current;

    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry && entry.isIntersecting && !hasFired.current) {
          hasFired.current = true;
          trackComparisonTableViewed(verticalSlug);
          observer.disconnect();
        }
      },
      { threshold: 0.3 },
    );

    observer.observe(el);

    return () => observer.disconnect();
  }, [verticalSlug]);

  return <div ref={ref}>{children}</div>;
}
